export default "__VITE_ASSET__Nq54jSJ9__"